// @ts-check
import { LBButton, LBChevronDownIcon, LBChevronUpIcon } from '@linearb/buzz';

const ShowMoreToggler = ({ isShowMore, showMore, showLess }) => {
  return (
    <div className='mt-2 mb-4 ml-2'>
      <LBButton
        variant='ghost'
        size='sm'
        onClick={isShowMore ? showMore : showLess}
      >
        View {isShowMore ? 'more' : 'less'}
        {isShowMore ? <LBChevronDownIcon /> : <LBChevronUpIcon />}
      </LBButton>
    </div>
  );
};

export default ShowMoreToggler;
